import axios from "axios";

const BASE_API_URL = "/api/consult";

//專業諮詢（使用者端）：登入靠 httpOnly cookie，前端不碰 token
class ConsultService {
  //取得（或惰性建立）某訂單的諮詢串
  getThread(orderID) {
    return axios.post(BASE_API_URL + "/thread", { orderID });
  }

  //送出諮詢訊息（{ consultID, content, replyTo }；首次免費，追問扣 A-Point）
  //  自動帶 platform: "0"（對齊 User.osType："0" Web / "1" iOS / "2" Android）
  //  → 後端據此決定通知走 email 還是 push；App 端自己的 service 帶 "1"/"2"
  sendMessage(payload) {
    return axios.post(BASE_API_URL + "/message", {
      ...payload,
      platform: "0",
    });
  }

  //對某則客服回覆評分（{ consultID, messageID, stars }）
  rate(payload) {
    return axios.post(BASE_API_URL + "/rate", payload);
  }

  //諮詢未讀狀態（nav 驚嘆號用）→ { askTeacher, study }
  //  用 POST 避開 iOS Safari 對 GET 的積極 cache（跟同檔案其他 endpoint 對齊）
  getUnread() {
    return axios.post(BASE_API_URL + "/unread");
  }
}

export default new ConsultService();
